import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";

const F = [["intensity", "RPE"], ["sets", "Series"], ["reps", "Reps / duración"], ["rest", "Descanso"]];

export const SessionEditor = ({ sid, onDone }) => {
  const [d, setD] = useState(null);
  const [vals, setVals] = useState({});
  const [note, setNote] = useState("");
  useEffect(() => {
    let alive = true;
    api.get(`/admin/autoreg/sessions/${sid}`).then((r) => {
      if (!alive) return;
      setD(r.data);
      const v = {};
      r.data.session.blocks.forEach((b) => b.exercises.forEach((e) => { v[e.id] = Object.fromEntries(F.map(([k]) => [k, r.data.adjustment?.exercises?.[e.id]?.[k] ?? e[k] ?? ""])); }));
      setVals(v);
    }).catch((e) => alive && toast.error(formatErr(e)));
    return () => { alive = false; };
  }, [sid]);
  if (!d) return <div style={{ color: "#a3a3a3" }}>Cargando…</div>;
  const set = (eid, k, v) => setVals({ ...vals, [eid]: { ...vals[eid], [k]: v } });
  const save = () => api.put(`/admin/autoreg/sessions/${sid}/adjustment`, { exercises: vals, note: note || null })
    .then(() => { toast.success("Sesión guardada. Tu edición tiene prioridad sobre la automatización."); onDone(); }).catch((e) => toast.error(formatErr(e)));
  return (
    <div className="qv-card-app" style={{ padding: 12, marginTop: 8 }} data-testid={`ar-editor-${sid}`}>
      <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 8 }}>Solo puedes cambiar RPE, series, repeticiones y descansos. Entre paréntesis, el valor de la sesión base.</div>
      {d.session.blocks.map((b) => b.exercises.map((e) => (
        <div key={e.id} style={{ display: "grid", gridTemplateColumns: "minmax(140px, 1.4fr) repeat(4, 1fr)", gap: 6, alignItems: "end", marginBottom: 6, fontSize: 12 }}>
          <div><b>{e.name}</b><div style={{ color: "#737373", fontSize: 11 }}>{b.type}</div></div>
          {F.map(([k, l]) => (
            <label key={k} style={{ color: "#a3a3a3", fontSize: 11 }}>{l} ({e[k] || "—"})
              <input className="qv-input" style={{ textTransform: "none", padding: "5px 6px", fontSize: 12 }} value={vals[e.id]?.[k] ?? ""} onChange={(x) => set(e.id, k, x.target.value)} data-testid={`ar-ed-${e.id}-${k}`} />
            </label>
          ))}
        </div>
      )))}
      <input className="qv-input" style={{ textTransform: "none", marginTop: 6 }} placeholder="Nota (visible como motivo para el jugador)" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`ar-ed-note-${sid}`} />
      <button className="qv-btn-primary" style={{ marginTop: 8 }} onClick={save} data-testid={`ar-ed-save-${sid}`}>Guardar edición</button>
    </div>
  );
};
